"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedPointInitializer = exports.RandomInitializer = void 0;
const tfjs_core_1 = require("@tensorflow/tfjs-core");
class Initializer {
}
class RandomInitializer extends Initializer {
    /**
     * This class implements the initialization of the theta parameter following a probability law (uniform or normal)
     * @param distributionType : type of distribution used to initialize theta
     * @param distributionParams : parameters of the chosen distribution
     * @param dim : number of dimensions
     */
    constructor(distributionType = "normal", distributionParams = [0, 1], dim = 2) {
        super();
        var availableDistributions = ["uniform", "normal"];
        if (!(availableDistributions.includes(distributionType))) {
            throw new Error(distributionType + " does not belong to available distributions");
        }
        this._distType = distributionType;
        this._distParams = distributionParams;
        this._dim = dim;
    }
    initialize() {
        if (this._distType == "uniform") {
            var theta = (0, tfjs_core_1.randomUniform)([this._dim], Math.min(...this._distParams), Math.max(...this._distParams)).dataSync();
        }
        else { //} if (this._distType == "normal"){
            var theta = (0, tfjs_core_1.randomNormal)([this._dim], this._distParams[0], this._distParams[1]).dataSync();
        }
        return theta;
    }
}
exports.RandomInitializer = RandomInitializer;
class FixedPointInitializer extends Initializer {
    /**
     * This class implements the initialisation to theta to a fixed value defined by the user
     * @param val : value of theta in each dimension
     * @param dim : number of dimensions
     */
    constructor(val, dim) {
        super();
        this._val = val;
        this._dim = dim;
    }
    initialize() {
        return new Float32Array(this._dim).fill(this._val);
    }
}
exports.FixedPointInitializer = FixedPointInitializer;
